module.exports = __webpack_public_path__ + "static/media/model-mission-9.f0828447.png";